import { useRef } from "react";

const Magnetic = ({ children, className="", strength=0.3 }) => {
  const ref = useRef(null);
  return <span ref={ref} className={`magnetic inline-block ${className}`} onMouseMove={e=>{const el=ref.current;if(!el)return;const r=el.getBoundingClientRect();el.style.transform=`translate(${(e.clientX-r.left-r.width/2)*strength}px,${(e.clientY-r.top-r.height/2)*strength}px)`;el.style.transition="transform 0.2s ease-out"}} onMouseLeave={()=>{const el=ref.current;if(!el)return;el.style.transform="translate(0,0)";el.style.transition="transform 0.5s cubic-bezier(0.16,1,0.3,1)"}}>{children}</span>;
};

export default Magnetic;